import React from "react"

import classNames from "classnames"

import { useEvent } from "shared/lib/useEvent"
import { Entry } from "shared/types/Entry"
import { Button, ButtonProps } from "shared/ui/buttons/Button"

interface ColorInputButtonProps extends Omit<ButtonProps, "color" | "onClick"> {
  color: Entry<string>
  onColorChange: (color: string) => void
  isSelected?: boolean
}

export const ColorInputButton = React.memo(
  React.forwardRef(
    (
      { color, onColorChange, isSelected, ...rest }: ColorInputButtonProps,
      ref: React.ForwardedRef<HTMLButtonElement>
    ) => {
      const handleColorChange = useEvent(() => {
        onColorChange(color.value)
      })

      const name = color.label || color.value

      return (
        <Button
          key={color.value}
          {...rest}
          ref={ref}
          title={name}
          aria-label={name}
          aria-pressed={isSelected}
          className={classNames("color-input__button", {
            "color-input__button--selected": isSelected
          })}
          style={{ backgroundColor: color.value }}
          onClick={handleColorChange}
        />
      )
    }
  )
)

ColorInputButton.displayName = "ColorInputButton"
